// Global application event names and payload contracts

export const UNAUTHORIZED_EVENT = 'iehub:unauthorized';

export interface UnauthorizedEventDetail {
  readonly reason: string;
  readonly url?: string;
  readonly method?: string;
}

